/* eslint-disable */
import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, ButtonGroup, Grid, Typography, Tooltip, IconButton } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import services from '../../Service';
import { ToastContainer, toast } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import Paper from '@material-ui/core/Paper';
import { LoadingComponent } from 'src/pages/pageLoader';
import { AlertDialog } from './../../../Common/AlertDialog';
import TokenDecoder from 'src/helpers/TokenDecoder';
import 'react-toastify/dist/ReactToastify.css';
import Page from '../../../../Page';
import Divider from '@material-ui/core/Divider';
import EditIcon from '@material-ui/icons/Edit';
import { trackPromise } from 'react-promise-tracker';

export function IncomeAndAsset({ handleNext, handleBack, farmerId }) {
    const [dataGridIncome, setDataGridIncome] = useState([]);
    const [message, setMessage] = useState("Primary Income Delete Confirmation");
    const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
    const [message1, setMessage1] = useState("Vehicle Details Delete Confirmation");
    const [EnableConfirmMessage1, setEnableConfirmMessage1] = useState(false);
    const [dataGridVehicle, setDatagridVehicle] = useState([]);
    const [dataGrid, setDataGrid] = useState([]);
    const [OwnershipOfFarmingLandTypeList, setOwnershipOfFarmingLandTypeList] = useState([]);
    const [factoryType, setFactoryType] = useState(0);
    const [farmerIncomeID, setFarmerIncomeID] = useState(0);
    const [farmerVehicleID, setFarmerVehicleID] = useState(0);
    const [allDisableButton, setAllDisableButton] = useState(false);
    const [pageProps, setPageProps] = useState({
        farmerId: farmerId,
        editingID: 0,
        Edit: false,
        buttonEnable: 0,
        submitButtonName: "Add",
        pageheadername: "Add Income and Assets "
    });
    const [formData, setFormData] = useState({
        farmerVehicleID: '',
        farmerId: pageProps.farmerId,
        vehicleOwnership: 1,
        vehicleType: 0,
        otherVehicleType: '',
        vehicalNumber: '',
        isTranspotationOfProduce: 0
    });


    const [incomeData, setIncomeData] = useState({
        farmerIncomeID: '',
        farmerId: pageProps.farmerId,
        isPrimaryIncome: 1,
        sourceOfIncome: 0,
        otherSurceOfIncome: '',
        ownershipOfFarmingLandID: 0,
        otherOwnershipOfFarmingLand: '',
    });



    const IncomeAssetSaveSchema = Yup.object().shape({
        vehicleOwnership: Yup.string().required('Vehicle Ownership required'),
        vehicleType: Yup.string().required('Vehicle Type required'),
        otherVehicleType: Yup.string(),
        isPrimaryIncome: Yup.string().required('Primary Account Number required'),
        sourceOfIncome: Yup.string().required('Source of Income required'),
        otherSurceOfIncome: Yup.string()
    });
    const formik = useFormik({
        initialValues: {
            vehicleOwnership: formData.vehicleOwnership,
            vehicleType: formData.vehicleType,
            otherVehicleType: formData.otherVehicleType,
            primaryIncomeID: incomeData.isPrimaryIncome,
            sourceOfIncome: incomeData.sourceOfIncome,
            otherSurceOfIncome: incomeData.otherSurceOfIncome,
            ownershipOfFarmingLandID: incomeData.ownershipOfFarmingLandID,
            otherOwnershipOfFarmingLand: incomeData.otherOwnershipOfFarmingLand
        },

        validationSchema: IncomeAssetSaveSchema,
        onSubmit: (values) => {
            addGrid(values)
        },
        enableReinitialize: true

    });

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        GetSupplierTypeIDbyFarmerID(farmerId);
        GetFarmerIncomeVehicleData(pageProps.farmerId);
        GetAllOwnershipOfFarmingLandTypes();
    }, []);

    async function GetSupplierTypeIDbyFarmerID(farmerId) {
        const res = await services.GetSupplierTypeIDbyFarmerID(farmerId)
        if (res == 2) {
            setAllDisableButton(true)
        }
        else {
            setAllDisableButton(false)
        }
        setDataGrid(res)
    }

    async function GetAllOwnershipOfFarmingLandTypes() {
        const response = await services.GetAllOwnershipOfFarmingLandTypes();
        setOwnershipOfFarmingLandTypeList(response);
    }

    async function clearOtherTypeOfVehicle() {
        setFormData({
            ...formData,
            farmerVehicleID: '',
            farmerId: pageProps.farmerId,
            vehicleType: 0,
            otherVehicleType: '',
            vehicalNumber: '',
            isTranspotationOfProduce: 0
        })
        setPageProps({
            ...pageProps,
            submitButtonName: "Add",
            Edit: false,
            buttonEnable: 0
        })
        GetFarmerIncomeVehicleData(pageProps.farmerId);
    }

    async function clearOtherSourceOfIncome() {
        setIncomeData({
            ...incomeData,
            farmerIncomeID: '',
            farmerId: pageProps.farmerId,
            isPrimaryIncome: 1,
            sourceOfIncome: 0,
            otherSurceOfIncome: '',
            ownershipOfFarmingLandID: 0,
            otherOwnershipOfFarmingLand: '',
        })
        setPageProps({
            ...pageProps,
            submitButtonName: "Add",
            Edit: false,
            buttonEnable: 0
        })
        GetFarmerIncomeVehicleData(pageProps.farmerId);
    }

    function handleVehicleDetailsChange(e) {
        const target = e.target;
        const value = target.value
        setFormData({
            ...formData,
            [e.target.name]: value
        });
    }

    function handleIncomeDetailsChange(e) {
        const target = e.target;
        const value = target.value
        setIncomeData({
            ...incomeData,
            [e.target.name]: value
        });
    }

    async function AddVehicleOwnership(vehicleData) {
        var reg = new RegExp('^((?!0000)([a-zA-Z]{1,3}|([0-9]{1,3}))-[0-9])|(([a-zA-Z]{1,3}|([0-9]{1,3}))-[0-9])(?!000)$');
        if (formData.vehicleOwnership === 1 && (formData.vehicleType == undefined || formData.vehicleType == '')) {
            toast.error("Fill Vehicle Type field");
        } else if (formData.vehicleOwnership === 1 && formData.vehicleType == 9 &&
            (formData.otherVehicleType == undefined || formData.otherVehicleType == '')) {
            toast.error("Fill Other Vehicle Type field");
        } else if (formData.vehicleOwnership === 1 && reg.test(formData.vehicalNumber) == false) {
            toast.error("Please enter valid Vehicle Number with (-)");
        } else if (formData.vehicleOwnership === 1 && formData.isTranspotationOfProduce == 0) {
            toast.error("Is This Vehicle Used In The Transportation of Produce Is Required");
        }
        else {
            if (pageProps.Edit != true) {
                var vehicleData = {
                    farmerId: pageProps.farmerId,
                    vehicleOwnershipID: formData.vehicleOwnership,
                    vehicleTypeID: formData.vehicleType,
                    otherVehicleType: formData.vehicleType != 9 ? "" : formData.otherVehicleType,
                    vehicalNumber: formData.vehicalNumber,
                    isTranspotationOfProduce: formData.isTranspotationOfProduce,
                    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                }
                const res = await services.SaveVehicleData(vehicleData);
                setFormData({});
                if (res.statusCode == 'Success') {
                    toast.success("Farmer Vehicle Details Saved Succesfully")
                    GetFarmerIncomeVehicleData(pageProps.farmerId);
                    clearOtherTypeOfVehicle();
                } else {
                    toast.error("Error occured in Farmer Vehicle Details.");
                    GetFarmerIncomeVehicleData(pageProps.farmerId);
                    clearOtherTypeOfVehicle();
                }
            }
            else {
                var vehicleData = {
                    farmerVehicleID: formData.farmerVehicleID,
                    farmerId: pageProps.farmerId,
                    vehicleOwnershipID: formData.vehicleOwnership,
                    vehicleTypeID: formData.vehicleType,
                    otherVehicleType: formData.vehicleType != 9 ? "" : formData.otherVehicleType,
                    vehicalNumber: formData.vehicalNumber,
                    isTranspotationOfProduce: formData.isTranspotationOfProduce,
                    createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                }
                const responseUdate = await services.UpdateFarmerVehicleById(vehicleData);

                setFormData({});
                if (responseUdate.statusCode == 'Success') {
                    toast.success("Farmer Vehicle Details Updated Succesfully")
                    GetFarmerIncomeVehicleData(pageProps.farmerId);
                    clearOtherTypeOfVehicle();
                } else {
                    toast.error("Error occured in Farmer Vehicle Details.");
                    GetFarmerIncomeVehicleData(pageProps.farmerId);
                    clearOtherTypeOfVehicle();
                }
            }
        }
    }

    async function AddIncomeData(farmerIncomeData) {
        if (allDisableButton) {
            if (incomeData.sourceOfIncome == 6 &&
                (incomeData.otherSurceOfIncome == undefined || incomeData.otherSurceOfIncome == '')) {
                toast.error("Fill Other Sources of Income field");

            }
            else if (incomeData.sourceOfIncome == 0) {
                toast.error("Other Sources of Income Is Required");
            }
            else {
                if (pageProps.Edit != true) {
                    var farmerIncomeData = {
                        farmerId: pageProps.farmerId,
                        primaryIncomeID: incomeData.isPrimaryIncome,
                        sourceOfIncome: incomeData.sourceOfIncome,
                        otherSurceOfIncome: incomeData.otherSurceOfIncome == null || incomeData.sourceOfIncome != 6 ? "" : incomeData.otherSurceOfIncome,
                        ownershipOfFarmingLandID: parseInt(incomeData.ownershipOfFarmingLandID),
                        otherOwnershipOfFarmingLand: incomeData.otherOwnershipOfFarmingLand == null || incomeData.ownershipOfFarmingLandID != 7 ? "" : incomeData.otherOwnershipOfFarmingLand,
                        createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                    }
                    const res = await services.SaveIncomeData(farmerIncomeData);
                    setIncomeData({});
                    if (res.statusCode == 'Success') {
                        toast.success(res.message)
                        GetFarmerIncomeVehicleData(pageProps.farmerId);
                        clearOtherSourceOfIncome();
                    } else {
                        toast.error(res.message);
                        GetFarmerIncomeVehicleData(pageProps.farmerId);
                        clearOtherSourceOfIncome();
                    }
                }
                else {
                    var farmerIncomeData = {
                        farmerId: pageProps.farmerId,
                        farmerIncomeID: incomeData.farmerIncomeID,
                        primaryIncomeID: incomeData.isPrimaryIncome,
                        sourceOfIncome: incomeData.sourceOfIncome,
                        otherSurceOfIncome: incomeData.otherSurceOfIncome == null || incomeData.sourceOfIncome != 6 ? "" : incomeData.otherSurceOfIncome,
                        ownershipOfFarmingLandID: parseInt(incomeData.ownershipOfFarmingLandID),
                        otherOwnershipOfFarmingLand: incomeData.otherOwnershipOfFarmingLand == null || incomeData.ownershipOfFarmingLandID != 7 ? "" : incomeData.otherOwnershipOfFarmingLand,
                        createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                    }
                    const responseUpdate = await services.UpdateFarmerIncomeById(farmerIncomeData);
                    setIncomeData({});
                    if (responseUpdate.statusCode == 'Success') {
                        toast.success(responseUpdate.message);
                        GetFarmerIncomeVehicleData(pageProps.farmerId);
                        clearOtherSourceOfIncome();
                    } else {
                        toast.error(responseUpdate.message);
                        GetFarmerIncomeVehicleData(pageProps.farmerId);
                        clearOtherSourceOfIncome();
                    }
                }
            }

        } else {
            if (incomeData.sourceOfIncome == 6 &&
                (incomeData.otherSurceOfIncome == undefined || incomeData.otherSurceOfIncome == '')) {
                toast.error("Fill Other Sources of Income field");

            }
            else if (incomeData.ownershipOfFarmingLandID == 7 &&
                (incomeData.otherOwnershipOfFarmingLand == undefined || incomeData.otherOwnershipOfFarmingLand == '')) {
                toast.error("Fill Other Ownership of Farming Land");
            }

            else if (incomeData.sourceOfIncome == 0) {
                toast.error("Other Sources of Income Is Required");
            }
            else if (incomeData.ownershipOfFarmingLandID == 0) {
                toast.error("Ownership of Farming Land/s Is Required");
            }
            else {
                if (pageProps.Edit != true) {
                    var farmerIncomeData = {
                        farmerId: pageProps.farmerId,
                        primaryIncomeID: incomeData.isPrimaryIncome,
                        sourceOfIncome: incomeData.sourceOfIncome,
                        otherSurceOfIncome: incomeData.otherSurceOfIncome == null || incomeData.sourceOfIncome != 6 ? "" : incomeData.otherSurceOfIncome,
                        ownershipOfFarmingLandID: parseInt(incomeData.ownershipOfFarmingLandID),
                        otherOwnershipOfFarmingLand: incomeData.otherOwnershipOfFarmingLand == null || incomeData.ownershipOfFarmingLandID != 7 ? "" : incomeData.otherOwnershipOfFarmingLand,
                        createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                    }
                    const res = await services.SaveIncomeData(farmerIncomeData);
                    setIncomeData({});
                    if (res.statusCode == 'Success') {
                        toast.success(res.message)
                        GetFarmerIncomeVehicleData(pageProps.farmerId);
                        clearOtherSourceOfIncome();
                    } else {
                        toast.error(res.message);
                        GetFarmerIncomeVehicleData(pageProps.farmerId);
                        clearOtherSourceOfIncome();
                    }
                }
                else {
                    var farmerIncomeData = {
                        farmerId: pageProps.farmerId,
                        farmerIncomeID: incomeData.farmerIncomeID,
                        primaryIncomeID: incomeData.isPrimaryIncome,
                        sourceOfIncome: incomeData.sourceOfIncome,
                        otherSurceOfIncome: incomeData.otherSurceOfIncome == null || incomeData.sourceOfIncome != 6 ? "" : incomeData.otherSurceOfIncome,
                        ownershipOfFarmingLandID: parseInt(incomeData.ownershipOfFarmingLandID),
                        otherOwnershipOfFarmingLand: incomeData.otherOwnershipOfFarmingLand == null || incomeData.ownershipOfFarmingLandID != 7 ? "" : incomeData.otherOwnershipOfFarmingLand,
                        createdBy: parseInt(TokenDecoder.getUserIDFromToken()),
                    }
                    const responseUpdate = await services.UpdateFarmerIncomeById(farmerIncomeData);
                    setIncomeData({});
                    if (responseUpdate.statusCode == 'Success') {
                        toast.success(responseUpdate.message);
                        GetFarmerIncomeVehicleData(pageProps.farmerId);
                        clearOtherSourceOfIncome();
                    } else {
                        toast.error(responseUpdate.message);
                        GetFarmerIncomeVehicleData(pageProps.farmerId);
                        clearOtherSourceOfIncome();
                    }
                }
            }
        }


    }

    function confirmData(y) {
        if (y) {
            handleDeleteIncome(farmerIncomeID);
        }
    }

    function DeleteFarmerIncomeDetailsPopUp(data) {
        setFarmerIncomeID(data);
        setEnableConfirmMessage(true);
    }

    function confirmData1(y) {
        if (y) {
            handleDeleteVehicle(farmerVehicleID);
        }
    }

    function DeleteFarmerVehicleDetailsPopUp(data) {
        setFarmerVehicleID(data);
        setEnableConfirmMessage1(true);
    }


    async function GetFarmerIncomeVehicleData(id) {
        const res = await services.GetIncomeandVehicleData(parseInt(id));
        setDataGridIncome(res.incomeDetails);
        setDatagridVehicle(res.vehicleDetails);
        setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
    }

    async function DeleteFarmerIncomeDetails(id) {
        const res = await services.DeleteFarmerIncomeDetails(parseInt(id));
        GetFarmerIncomeVehicleData(pageProps.farmerId);
    }

    async function DeleteFarmerVehicleDetails(id) {
        const res = await services.DeleteFarmerVehicleDetails(parseInt(id));
        GetFarmerIncomeVehicleData(pageProps.farmerId);
    }

    async function UpdateFarmerVehicleDetails(rowData, index) {
        var array = [...dataGridVehicle];
        setFormData({
            ...formData,
            farmerVehicleID: rowData.farmerVehicleID,
            farmerId: rowData.farmerId,
            vehicleOwnership: rowData.vehicleOwnershipID,
            vehicleType: rowData.vehicleTypeID,
            otherVehicleType: rowData.otherVehicleType,
            vehicalNumber: rowData.vehicalNumber,
            isTranspotationOfProduce: rowData.isTranspotationOfProduce,
        })
        array.splice(index, 1);
        setPageProps({
            ...pageProps,
            submitButtonName: "Update",
            Edit: true,
            buttonEnable: 1
        })
        setDatagridVehicle(array);
    }

    async function UpdateFarmerIncomeDetails(rowData, index) {
        var array = [...dataGridIncome];
        setIncomeData({
            ...incomeData,
            farmerIncomeID: rowData.farmerIncomeID,
            farmerId: rowData.farmerID,
            isPrimaryIncome: rowData.primaryIncomeID,
            sourceOfIncome: rowData.sourceOfIncome,
            otherSurceOfIncome: rowData.otherSurceOfIncome,
            ownershipOfFarmingLandID: rowData.ownershipOfFarmingLandID,
            otherOwnershipOfFarmingLand: rowData.otherOwnershipOfFarmingLand
        })
        array.splice(index, 1);

        setPageProps({
            ...pageProps,
            submitButtonName: "Update",
            Edit: true,
            buttonEnable: 2
        })
        setDataGridIncome(array);
    }

    async function handleDeleteIncome(data) {
        const res = await services.DeleteFarmerIncomeDetails(data);
        if (res.statusCode == 'Success') {
            toast.success(res.message);
            trackPromise(GetFarmerIncomeVehicleData(pageProps.farmerId));
        } else {
            toast.error(res.message);
        }
    }

    async function handleDeleteVehicle(data) {
        const res = await services.DeleteFarmerVehicleDetails(data);
        if (res.statusCode == 'Success') {
            toast.success(res.message);
            trackPromise(GetFarmerIncomeVehicleData(pageProps.farmerId));
        } else {
            toast.error(res.message);
        }
    }

    function generateOwnershipDropDownMenu(data) {
        let items = []
        if (data != null) {
            data.forEach(x => {
                items.push(<MenuItem key={x.ownershipOfFarmingLandTypeID} value={x.ownershipOfFarmingLandTypeID}>{x.ownershipOfFarmingLandTypeName}</MenuItem>)
            });
        }
        return items
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Income & Assets  |  FAPS">
                <Container>
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate onSubmit={handleSubmit}
                        >
                            <Card style={{ justifycontent: 'center' }} >
                                <Stack spacing={2} margin={3}>
                                    <Typography variant="h6">
                                        {(factoryType == 1 || factoryType == 3) ? "View Income and Assets" : "Income & Assets Details"}
                                        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" >
                                            <ButtonGroup disableElevation variant="outlined" color="primary">
                                                <Tooltip title="Farming">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleBack}
                                                    >
                                                        <ArrowBackIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Contact Person">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={handleNext}
                                                    >
                                                        <ArrowForwardIosOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </Stack>
                                    </Typography>
                                    <Card style={{ justifycontent: 'center' }}>
                                        <Container>
                                            <br />
                                            <Typography variant="h6">
                                                {(factoryType == 1 || factoryType == 3) ? "View Vehicle Details" : "Vehicle Details"}
                                            </Typography>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                                <TextField select
                                                    fullWidth
                                                    size="small"
                                                    label="Vehicle Ownership *"
                                                    value={formData.vehicleOwnership}
                                                    name='vehicleOwnership'
                                                    onChange={(e) => { handleVehicleDetailsChange(e) }}
                                                    error={Boolean(touched.vehicleOwnership && errors.vehicleOwnership)}
                                                    helperText={touched.vehicleOwnership && errors.vehicleOwnership}
                                                    disabled={factoryType == 1 || factoryType == 3}
                                                >
                                                    <MenuItem key={0} value={0}> No</MenuItem>
                                                    <MenuItem value={1}>Yes</MenuItem>
                                                </TextField>
                                                {formData.vehicleOwnership == 1 ?
                                                    <TextField select
                                                        fullWidth
                                                        size="small"
                                                        label="Vehicle Type *"
                                                        name='vehicleType'
                                                        value={formData.vehicleType}
                                                        onChange={(e) => { handleVehicleDetailsChange(e) }}
                                                        error={Boolean(touched.vehicleType && errors.vehicleType)}
                                                        helperText={touched.vehicleType && errors.vehicleType}
                                                        disabled={factoryType == 1 || factoryType == 3}
                                                    >
                                                        <MenuItem key={0} value={0}> Select Vehicle Type</MenuItem>
                                                        <MenuItem value={1}>Motor Bike</MenuItem>
                                                        <MenuItem value={2}>Three Wheeler</MenuItem>
                                                        <MenuItem value={3}>Car</MenuItem>
                                                        <MenuItem value={4}>SUV</MenuItem>
                                                        <MenuItem value={5}>Van</MenuItem>
                                                        <MenuItem value={6}>Truck</MenuItem>
                                                        <MenuItem value={7}>Tractor</MenuItem>
                                                        <MenuItem value={8}>Land Master</MenuItem>
                                                        <MenuItem value={9}>Other</MenuItem>
                                                    </TextField>
                                                    : null}

                                                {formData.vehicleType == 9 && formData.vehicleOwnership == 1 ?
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        name='otherVehicleType'
                                                        label=" Other Vehicle Type *"
                                                        value={formData.otherVehicleType}
                                                        onChange={(e) => { handleVehicleDetailsChange(e) }}
                                                        error={Boolean(touched.otherVehicleType && errors.otherVehicleType)}
                                                        helperText={touched.otherVehicleType && errors.otherVehicleType}
                                                        disabled={factoryType == 1 || factoryType == 3}
                                                    />
                                                    : null}
                                                {formData.vehicleOwnership == 0 && pageProps.buttonEnable != 2 ?
                                                    <LoadingButton
                                                        size="medium"
                                                        type="button"
                                                        variant="outlined"
                                                        color='secondary'
                                                        disabled={factoryType == 1 || factoryType == 3}
                                                        onClick={AddVehicleOwnership}
                                                    >
                                                        {pageProps.submitButtonName}
                                                    </LoadingButton>
                                                    : null}
                                            </Stack>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '20px' }} spacing={2}>
                                                {formData.vehicleOwnership == 1 ?
                                                    <Grid item xs={4} sm={4} md={4}>
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            name='vehicalNumber'
                                                            label="Vehicle Number *"
                                                            value={formData.vehicalNumber}
                                                            onChange={(e) => { handleVehicleDetailsChange(e) }}
                                                            error={Boolean(touched.vehicalNumber && errors.vehicalNumber)}
                                                            helperText={touched.vehicalNumber && errors.vehicalNumber}
                                                            disabled={factoryType == 1 || factoryType == 3}
                                                        />
                                                    </Grid> : <Grid item xs={4} sm={4} md={4}></Grid>}
                                                {formData.vehicleOwnership == 1 ?
                                                    <Grid item xs={4} sm={4} md={4}>
                                                        <TextField select
                                                            fullWidth
                                                            size="small"
                                                            name='isTranspotationOfProduce'
                                                            label="Is This Vehicle Used In The Transportation of Produce ? *"
                                                            value={formData.isTranspotationOfProduce}
                                                            onChange={(e) => { handleVehicleDetailsChange(e) }}
                                                            error={Boolean(touched.isTranspotationOfProduce && errors.isTranspotationOfProduce)}
                                                            helperText={touched.isTranspotationOfProduce && errors.isTranspotationOfProduce}
                                                            disabled={factoryType == 1 || factoryType == 3}
                                                        >
                                                            <MenuItem key={0} value={0}> Select Is This Vehicle Used In The Transportation of Produce</MenuItem>
                                                            <MenuItem value={1}>Yes</MenuItem>
                                                            <MenuItem value={2}>No</MenuItem>
                                                        </TextField>
                                                    </Grid> : <Grid item xs={4} sm={4} md={4}></Grid>}
                                                <Grid item xs={4} sm={4} md={4}>
                                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                                        {formData.vehicleOwnership == 1 && pageProps.buttonEnable != 2 ?
                                                            <LoadingButton
                                                                size="medium"
                                                                type="button"
                                                                variant="outlined"
                                                                color='error'
                                                                onClick={() => (clearOtherTypeOfVehicle())}
                                                                disabled={factoryType == 1 || factoryType == 3}
                                                            >
                                                                Clear
                                                            </LoadingButton>
                                                            : null}
                                                        {formData.vehicleOwnership == 1 && pageProps.buttonEnable != 2 ?
                                                            <LoadingButton
                                                                size="medium"
                                                                type="button"
                                                                variant="outlined"
                                                                color='secondary'
                                                                disabled={factoryType == 1 || factoryType == 3}
                                                                onClick={AddVehicleOwnership}
                                                            >
                                                                {pageProps.submitButtonName}
                                                            </LoadingButton>
                                                            : null}
                                                    </Stack>
                                                </Grid>
                                            </Stack>
                                            <br />
                                            <Divider variant="middle" />
                                            {(dataGridVehicle.length > 0) ?
                                                <Table aria-label="collapsible table">
                                                    <TableHead>
                                                        <TableRow >
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>Vehicle Ownership</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>Vehicle Type</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>Other Vehicle Type</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>Vehicle Number</TableCell>
                                                            {(factoryType == 1 || factoryType == 3) ? null :
                                                                <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {dataGridVehicle.map((rowData, index) => (
                                                            <TableRow key={rowData.vehicleTypeID}>
                                                                <TableCell align="center" >{rowData.vehicleOwnershipID == 0 ? 'No' : 'Yes'}</TableCell>
                                                                <TableCell align="center" >{
                                                                    rowData.vehicleTypeID == 1 ? 'Motor Bike'
                                                                        : rowData.vehicleTypeID == 2 ? 'Three Wheeler'
                                                                            : rowData.vehicleTypeID == 3 ? 'Car'
                                                                                : rowData.vehicleTypeID == 4 ? 'SUV'
                                                                                    : rowData.vehicleTypeID == 5 ? 'Van'
                                                                                        : rowData.vehicleTypeID == 6 ? 'Truck'
                                                                                            : rowData.vehicleTypeID == 7 ? 'Tractor'
                                                                                                : rowData.vehicleTypeID == 8 ? 'Land Master'
                                                                                                    : rowData.vehicleTypeID == 9 ? 'Other' : '-'
                                                                }</TableCell>
                                                                <TableCell align="center" >{rowData.otherVehicleType == null ? '-' : rowData.otherVehicleType}</TableCell>
                                                                <TableCell align="center" >{rowData.vehicalNumber == null ? '-' : rowData.vehicalNumber}</TableCell>
                                                                {(factoryType == 1 || factoryType == 3) ? null :
                                                                    <TableCell align="center" >
                                                                        {pageProps.Edit != true ?
                                                                            <Tooltip title="Edit">
                                                                                <IconButton
                                                                                    variant="outlined"
                                                                                    onClick={() => UpdateFarmerVehicleDetails(rowData, index)}>
                                                                                    <EditIcon />
                                                                                </IconButton>
                                                                            </Tooltip> : null}
                                                                        {pageProps.Edit != true ?
                                                                            <Tooltip title="Delete">
                                                                                <IconButton
                                                                                    variant="outlined"
                                                                                    color="error"
                                                                                    onClick={(e) => DeleteFarmerVehicleDetailsPopUp(rowData.farmerVehicleID)}
                                                                                >
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </Tooltip> : null}
                                                                    </TableCell>}
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                : null}
                                        </Container>
                                    </Card>
                                    <Card style={{ justifycontent: 'center' }}>
                                        <Container>
                                            <br />
                                            <Typography variant="h6">
                                                {(factoryType == 1 || factoryType == 3) ? "View Primary Income" : "Primary Income"}
                                            </Typography>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                                <TextField select
                                                    fullWidth
                                                    size="small"
                                                    label="Primary Income *"
                                                    value={incomeData.isPrimaryIncome}
                                                    name='isPrimaryIncome'
                                                    onChange={(e) => { handleIncomeDetailsChange(e) }}
                                                    error={Boolean(touched.isPrimaryIncome && errors.isPrimaryIncome)}
                                                    helperText={touched.isPrimaryIncome && errors.isPrimaryIncome}
                                                    disabled={factoryType == 1 || factoryType == 3}
                                                >
                                                    <MenuItem key={0} value={0}> No</MenuItem>
                                                    <MenuItem value={1}>Yes</MenuItem>
                                                </TextField>
                                                <TextField select
                                                    fullWidth
                                                    size="small"
                                                    label="Other Sources of Income *"
                                                    name='sourceOfIncome'
                                                    value={incomeData.sourceOfIncome}
                                                    onChange={(e) => { handleIncomeDetailsChange(e) }}
                                                    error={Boolean(touched.sourceOfIncome && errors.sourceOfIncome)}
                                                    helperText={touched.sourceOfIncome && errors.sourceOfIncome}
                                                    disabled={factoryType == 1 || factoryType == 3}
                                                >
                                                    <MenuItem key={0} value={0}> Select Other Sources of Income</MenuItem>
                                                    <MenuItem value={1}>Dairy</MenuItem>
                                                    <MenuItem value={2}>Livestock (Non-Dairy)</MenuItem>
                                                    <MenuItem value={3}>Private Sector Employment</MenuItem>
                                                    <MenuItem value={4}>Public Sector Employment</MenuItem>
                                                    <MenuItem value={6}>Other</MenuItem>
                                                    <MenuItem value={7}>None</MenuItem>
                                                </TextField>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="Other *"
                                                    value={incomeData.otherSurceOfIncome}
                                                    name='otherSurceOfIncome'
                                                    onChange={(e) => { handleIncomeDetailsChange(e) }}
                                                    error={Boolean(touched.otherSurceOfIncome && errors.otherSurceOfIncome)}
                                                    helperText={touched.otherSurceOfIncome && errors.otherSurceOfIncome}
                                                    disabled={factoryType == 1 || factoryType == 3 || incomeData.sourceOfIncome != 6}
                                                />
                                            </Stack>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '25px' }} spacing={2}>
                                                <Grid item xs={4} sm={4} md={4}>
                                                    <TextField select
                                                        fullWidth
                                                        size="small"
                                                        label="Ownership of Farming Land/s *"
                                                        name='ownershipOfFarmingLandID'
                                                        value={incomeData.ownershipOfFarmingLandID}
                                                        onChange={(e) => { handleIncomeDetailsChange(e) }}
                                                        error={Boolean(touched.ownershipOfFarmingLandID && errors.ownershipOfFarmingLandID)}
                                                        helperText={touched.ownershipOfFarmingLandID && errors.ownershipOfFarmingLandID}
                                                        disabled={factoryType == 1 || factoryType == 3 || allDisableButton}
                                                    >
                                                        <MenuItem key={0} value={0}> Select Ownership of Farming Land</MenuItem>
                                                        {generateOwnershipDropDownMenu(OwnershipOfFarmingLandTypeList)}
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={4} sm={4} md={4}>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Other Ownership of Farming Land *"
                                                        value={incomeData.otherOwnershipOfFarmingLand}
                                                        name='otherOwnershipOfFarmingLand'
                                                        onChange={(e) => { handleIncomeDetailsChange(e) }}
                                                        error={Boolean(touched.otherOwnershipOfFarmingLand && errors.otherOwnershipOfFarmingLand)}
                                                        helperText={touched.otherOwnershipOfFarmingLand && errors.otherOwnershipOfFarmingLand}
                                                        disabled={factoryType == 1 || factoryType == 3 || incomeData.ownershipOfFarmingLandID != 7 || allDisableButton}
                                                    />
                                                </Grid>
                                                <Grid item xs={4} sm={4} md={4}>
                                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                                        {pageProps.buttonEnable != 1 ?
                                                            <LoadingButton
                                                                size="medium"
                                                                type="button"
                                                                variant="outlined"
                                                                color='error'
                                                                onClick={() => clearOtherSourceOfIncome()}
                                                                disabled={factoryType == 1 || factoryType == 3}
                                                            >
                                                                Clear
                                                            </LoadingButton> : null}
                                                        {pageProps.buttonEnable != 1 ?
                                                            <LoadingButton
                                                                size="medium"
                                                                type="button"
                                                                variant="outlined"
                                                                color='secondary'
                                                                onClick={AddIncomeData}
                                                                disabled={factoryType == 1 || factoryType == 3}
                                                            >
                                                                {pageProps.submitButtonName}
                                                            </LoadingButton> : null}
                                                    </Stack>
                                                </Grid>
                                            </Stack>
                                            <br />
                                            <Divider variant="middle" />
                                            {(dataGridIncome.length > 0) ?
                                                <Table aria-label="collapsible table">
                                                    <TableHead>
                                                        <TableRow >
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>Primary Income</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>Other Sources of Income</TableCell>
                                                            <TableCell align="center" style={{ fontWeight: 'bold' }}>Other</TableCell>
                                                            {(factoryType == 1 || factoryType == 3) ? null :
                                                                <TableCell align="center" style={{ fontWeight: 'bold' }}>Action</TableCell>}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {dataGridIncome.map((rowData, index) => (
                                                            <TableRow key={rowData.sourceOfIncome}>
                                                                <TableCell align="center" >{rowData.primaryIncomeID == 0 ? 'No' : 'Yes'}</TableCell>
                                                                <TableCell align="center" >{
                                                                    rowData.sourceOfIncome == 1 ? 'Dairy'
                                                                        : rowData.sourceOfIncome == 2 ? 'Livestock (Non-Dairy)'
                                                                            : rowData.sourceOfIncome == 3 ? 'Private Sector Employment'
                                                                                : rowData.sourceOfIncome == 4 ? 'Public Sector Employment'
                                                                                    : rowData.sourceOfIncome == 6 ? 'Other'
                                                                                        : rowData.sourceOfIncome == 7 ? 'None' : '-'
                                                                }</TableCell>
                                                                <TableCell align="center" >{rowData.otherSurceOfIncome == null ? '-' : rowData.otherSurceOfIncome}</TableCell>
                                                                {(factoryType == 1 || factoryType == 3) ? null :
                                                                    <TableCell align="center" >
                                                                        {pageProps.Edit != true ?
                                                                            <Tooltip title="Edit">
                                                                                <IconButton
                                                                                    variant="outlined"
                                                                                    onClick={() => UpdateFarmerIncomeDetails(rowData, index)}>
                                                                                    <EditIcon />
                                                                                </IconButton>
                                                                            </Tooltip> : null}
                                                                        {pageProps.Edit != true ?
                                                                            <Tooltip title="Delete">
                                                                                <IconButton
                                                                                    variant="outlined"
                                                                                    color="error"
                                                                                    onClick={(e) => DeleteFarmerIncomeDetailsPopUp(rowData.farmerIncomeID)}
                                                                                >
                                                                                    <DeleteIcon />
                                                                                </IconButton>
                                                                            </Tooltip> : null}
                                                                    </TableCell>}
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                : null}
                                        </Container>
                                    </Card>
                                </Stack>
                                <br />
                            </Card>
                        </Form>
                    </FormikProvider>
                </Container>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData} headerMessage={message} viewPopup={EnableConfirmMessage}
                            discription={"Are you sure want to delete Farmer Primary Income details ?"} setViewPopup={setEnableConfirmMessage} />
                    </Grid>
                </div>
                <div hidden={true}>
                    <Grid item>
                        <AlertDialog confirmData={confirmData1} headerMessage={message1} viewPopup={EnableConfirmMessage1}
                            discription={"Are you sure want to delete Vehicle Details details ?"} setViewPopup={setEnableConfirmMessage1} />
                    </Grid>
                </div>
            </Page>
        </>
    )
}